export default {"src":"/_next/static/media/ic-search-black.c74a61c3.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};